import { zodResolver } from '@hookform/resolvers/zod'
import type { FieldValues } from 'react-hook-form'
import type { core } from 'zod'
import { missingAsRequired } from './form-errors'

/** react-hook-form resolver for `schema` that reports missing values as `Required`. */
export const requiredResolver = <
  T extends core.$ZodType<FieldValues, FieldValues>
>(
  schema: T
) => zodResolver(schema, { error: missingAsRequired })
